import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MilestoneStatusDoneIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M6.679 1.122a1.715 1.715 0 0 1 2.642 0L14.104 6.9a1.726 1.726 0 0 1 0 2.2l-4.783 5.778a1.715 1.715 0 0 1-2.642 0L1.896 9.1a1.726 1.726 0 0 1 0-2.2z"
				clipRule="evenodd"
			></path>
		</svg>
	),
)
